import { useDialogDepth } from "../Dialog/Internal/DialogDepthContext";
import { LAYER, overlayZIndex } from "./layers";

/**
 * The public way to place a portaled surface — a menu, dropdown, picker or
 * bespoke Radix popover — on the layer scale.
 *
 * Lives here rather than beside the context because the context is `Internal/`
 * and a barrel may not re-export from there; app code composing its own
 * portaled surface still needs these.
 */

/** Just above the dialog it was opened from, below anything that opens next. */
export function usePopoverZIndex(): number {
  return overlayZIndex(useDialogDepth(), LAYER.popoverOffset);
}

/** A notch above a popover, so a tooltip on a menu item clears the menu. */
export function useTooltipZIndex(): number {
  return overlayZIndex(useDialogDepth(), LAYER.tooltipOffset);
}
